import { SVGProps, useId } from "react";

export default function UserIconThinking(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, ...rest } = props;
  const id = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        opacity="0.4"
        d="M14.5254 2.16675C15.5753 2.16675 16.4335 3.01895 16.4336 4.07495C16.4254 5.10437 15.6173 5.93645 14.6025 5.97437C14.5481 5.97038 14.4939 5.97034 14.4395 5.97437C13.4234 5.93604 12.6172 5.10249 12.6172 4.07495C12.6173 3.02507 13.4694 2.16682 14.5254 2.16675Z"
        stroke={`url(#paint0_${id})`}
      />
      <path
        opacity="0.4"
        d="M14.5635 8.83984C15.4837 8.83101 16.3805 9.06033 17.043 9.5L17.0439 9.50098C17.5978 9.86557 17.807 10.2977 17.8076 10.665C17.8082 11.0328 17.6006 11.4666 17.0498 11.835C16.3929 12.2748 15.495 12.5028 14.5859 12.4971C14.7659 11.9313 14.8627 11.3327 14.8691 10.7139V10.709C14.8691 10.0587 14.7647 9.42767 14.5635 8.83984Z"
        stroke={`url(#paint1_${id})`}
      />
      <path
        opacity="0.4"
        d="M5.44727 2.16675C6.50329 2.16675 7.3554 3.02503 7.35547 4.07495C7.35547 5.10291 6.54883 5.93667 5.53223 5.97437C5.47777 5.9704 5.42359 5.97032 5.36914 5.97437C4.35492 5.93582 3.54725 5.10395 3.53906 4.07495C3.53913 3.01899 4.39738 2.16682 5.44727 2.16675Z"
        fill={`url(#paint2_${id})`}
        stroke={`url(#paint3_${id})`}
      />
      <path
        opacity="0.4"
        d="M5.25781 8.84009C5.06279 9.42681 4.95996 10.0552 4.95996 10.7083C4.95998 11.3335 5.05688 11.9365 5.23633 12.5042C4.38042 12.4842 3.55252 12.2521 2.92578 11.8401C2.3725 11.4715 2.16406 11.0379 2.16406 10.6702C2.16422 10.302 2.37378 9.86805 2.92871 9.49927L2.93066 9.49829C3.54576 9.08439 4.38884 8.85466 5.25781 8.84009Z"
        fill={`url(#paint4_${id})`}
        stroke={`url(#paint5_${id})`}
      />
      <path
        d="M9.99121 8C11.2982 8 12.3582 9.05923 12.3584 10.3662C12.3584 11.6439 11.3603 12.6778 10.0947 12.7246C10.0268 12.7197 9.95823 12.7199 9.89062 12.7246C8.6313 12.6788 7.625 11.6435 7.625 10.3662C7.62525 9.05843 8.677 8.00025 9.99121 8Z"
        fill={`url(#paint6_${id})`}
        stroke={`url(#paint7_${id})`}
      />
      <path
        d="M10.0039 14.731C10.8738 14.731 11.7148 14.9529 12.3271 15.3647L12.3301 15.3667C12.8529 15.7131 13.0498 16.1255 13.0498 16.4761C13.0497 16.8271 12.8521 17.2417 12.3281 17.5923C11.7109 18.005 10.8669 18.2271 9.99707 18.2271C9.12737 18.227 8.28414 18.0049 7.66699 17.5923L7.66504 17.5913L7.48438 17.4585C7.09611 17.1427 6.94531 16.7888 6.94531 16.4819C6.94534 16.1308 7.14278 15.7164 7.66699 15.3657L7.66602 15.3647C8.28794 14.9516 9.13455 14.731 10.0039 14.731Z"
        fill={`url(#paint8_${id})`}
        stroke={`url(#paint9_${id})`}
      />
      <defs>
        <linearGradient
          id={`paint0_${id}`}
          x1="14.5255"
          y1="1.66675"
          x2="14.5255"
          y2="6.47508"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint1_${id}`}
          x1="16.0719"
          y1="8.33984"
          x2="16.0719"
          y2="12.9983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint2_${id}`}
          x1="5.4474"
          y1="1.66675"
          x2="5.4474"
          y2="6.47508"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint3_${id}`}
          x1="5.4474"
          y1="1.66675"
          x2="5.4474"
          y2="6.47508"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint4_${id}`}
          x1="3.82448"
          y1="8.33911"
          x2="3.82448"
          y2="13.0062"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint5_${id}`}
          x1="3.82448"
          y1="8.33911"
          x2="3.82448"
          y2="13.0062"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint6_${id}`}
          x1="9.99167"
          y1="7.5"
          x2="9.99167"
          y2="13.225"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint7_${id}`}
          x1="9.99167"
          y1="7.5"
          x2="9.99167"
          y2="13.225"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint8_${id}`}
          x1="9.9974"
          y1="14.231"
          x2="9.9974"
          y2="18.7268"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint9_${id}`}
          x1="9.9974"
          y1="14.231"
          x2="9.9974"
          y2="18.7268"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
      </defs>
    </svg>
  );
}
